module.exports = __webpack_public_path__ + "static/iPhone_home-3b16ed227fbd8eadbd11954d4a1aea4a.png";